import { recordEvent } from "./events.functions";
import { hadLocalSession } from "./auth-recovery";

/**
 * Browser-side analytics helper. Fire-and-forget; never throws into UI.
 *
 *   track("page_viewed", { path: "/admin/dashboard" });
 *   track("run_retried_from_ui", undefined, { deal_id });
 *
 * For server-side emissions (run lifecycle, stripe webhooks) call
 * supabaseAdmin / dbProxy.insertEvent directly — those code paths don't
 * have a user session bound to the request.
 */
export function track(
  event_type: string,
  properties?: Record<string, unknown>,
  refs?: { deal_id?: string | null; report_id?: string | null; event_subtype?: string | null },
): void {
  // The events endpoint requires a session. Without one the call would 401,
  // so skip it outright instead of failing silently.
  if (typeof window !== "undefined" && !hadLocalSession()) return;
  void recordEvent({
    data: {
      event_type,
      event_subtype: refs?.event_subtype ?? null,
      deal_id: refs?.deal_id ?? null,
      report_id: refs?.report_id ?? null,
      properties: properties ?? {},
    },
  }).catch((err) => {
    // Analytics must never break the UI.
    console.warn("[track] failed", event_type, err);
  });
}